var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{staticClass:"rounded-lg",attrs:{"outlined":"","dense":"","label":_vm.label,"rules":_vm.rules,"type":"date"},on:{"input":_vm.save},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})
}
var staticRenderFns = []

export { render, staticRenderFns }